'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading = function Heading(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      id = _ref.id,
      classNames = _ref.classNames;

  if (!children) {
    return null;
  }

  return _react2.default.createElement(
    Tag,
    { id: id, className: 'c11n-heading ' + classNames.root },
    children
  );
};

Heading.propTypes = {
  /**
   * The html to be structured
   */
  children: _propTypes2.default.any,

  /**
   * The tag to be used for the containing element
   */
  tag: _propTypes2.default.string,

  /**
   * The ID attribute be added to the element (useful for navigation)
   */
  id: _propTypes2.default.string,

  /**
   * The theme color to be used for the heading
   */
  color: _propTypes2.default.string,

  /**
   * The size of the heading (using the font scale)
   */
  size: _propTypes2.default.number,

  /**
   * Disable the bottom margin of the heading
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),

  /**
   * Custom styles to be added to the element
   */
  styles: _propTypes2.default.object
};

Heading.defaultProps = {
  tag: 'h2',
  size: 3,
  spacing: { b: 0.5 },
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Heading);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/heading/index.js
// module id = 54
// module chunks = 0